var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostureExercising(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.9061 6.71094L16.6611 8.54197L17.8837 7.80191C18.2659 7.56891 18.8043 7.38382 19.1382 7.81006C19.4456 8.20246 19.3199 8.65532 18.946 8.9849L17.1736 10.3084C16.7875 10.583 16.2738 10.5975 15.8728 10.3451L13.5442 8.87962L13.9061 6.71094Z",
    fill: "#0D212C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0599 5.98741C16.2979 5.98741 17.3016 4.98374 17.3016 3.74566C17.3016 2.50757 16.2979 1.50391 15.0599 1.50391C13.8218 1.50391 12.8181 2.50757 12.8181 3.74566C12.8181 4.98374 13.8218 5.98741 15.0599 5.98741Z",
    fill: "#0D212C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9357 21.6108C19.33 21.2165 19.3784 20.5293 19.0433 20.0837L14.1325 13.5529L15.1101 9.30416C15.3968 8.0584 14.6332 6.8125 13.3931 6.50247L13.1382 6.43874C12.5345 6.28782 11.8976 6.34312 11.329 6.59585L7.8752 8.13088C7.39134 8.34592 7.12714 8.87315 7.24448 9.38947L7.76032 11.6591C7.84344 12.0249 8.17531 12.2795 8.55008 12.2651C9.00561 12.2475 9.34888 11.8444 9.29357 11.3919L9.08056 9.64912L11.176 9.33337L10.3196 12.188C10.1031 12.9098 10.2823 13.6923 10.7915 14.248L17.4549 21.5192C17.8434 21.9433 18.4979 21.9837 18.9357 21.6108Z",
    fill: "#0D212C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.1407 15.5242L11.2418 17.372C10.8788 18.118 9.94839 18.3836 9.24633 17.9415L5.40769 15.5242C5.02275 15.282 4.87759 14.7916 5.06866 14.3789C5.27986 13.9227 5.82259 13.7263 6.27681 13.9417L9.28983 15.3707L10.3195 12.1875L12.1407 15.5242Z",
    fill: "#0D212C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostureExercising);
export default __webpack_public_path__ + "static/media/PostureExercising.d17524a6aa10b93a708bc350f4376249.svg";
export { ForwardRef as ReactComponent };